import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewTipoComprbante = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'tipo_comprobante',
        name: 'Tipo Comprobante',
        component: ViewTipoComprbante,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
